import React, { useEffect } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { auditLogService } from "../Services/AuditLogService";
import { useSelector } from "react-redux";

const FinalScreen = ({
  alreadyCompleted = false,
  noKycData = false,
  noApplicantId = false, 
}) => {

  const customerSession = localStorage.getItem("session");
  const sessionId = localStorage.getItem("session_id"); 

  useEffect(() => {
    window.scrollTo(0, 0);

    // Only trigger KYC completion if valid applicant exists and not already completed
    const triggerCompletionNotification = async () => {
       // 🔹 Only run when KYC is actually "Submitted"
       console.log("session ",customerSession)
       console.log("alreadyCompleted ",alreadyCompleted)
       console.log("noKycData ",noKycData)
       console.log("noApplicantId ",noApplicantId)
       const isKycSubmitted = !alreadyCompleted && !noKycData && !noApplicantId;
       if (!isKycSubmitted) return; // prevent unnecessary API calls
//       await auditLogService.finalSubmission(customerSession, sessionId);
       console.log("KYC completion processed successfully");
       localStorage.removeItem("session");
       localStorage.removeItem("session_id");
    };

    triggerCompletionNotification();
  }, []);

  // 🧩 Define messages based on state
  const title = noApplicantId
    ? "Missing Session ID"
    : noKycData
    ? "Session No Longer Active"
    : alreadyCompleted
    ? "KYC Already Completed"
    : "KYC Submitted";

  const message = noApplicantId
    ? "We could not find a valid session ID. Please start the KYC process from your registered link."
    : noKycData
    ? "Your VKYC link has expired. Please reach out to your admin to receive a new Verification link and continue your verification."
    : alreadyCompleted
    ? "You have already completed your KYC process. Thank you!"
    : "Your KYC is under process. We will inform you shortly.";

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 4, px: 2 }}>
      <Card
        sx={{
          width: "100%",
          maxWidth: 600,
          borderRadius: 3,
          p: 3,
          textAlign: "center",
        }}
      >
        <CardContent>
          <Typography variant="h5" fontWeight="bold" color="primary" gutterBottom>
            {title}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {message}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default FinalScreen;
